import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=f7adc38a&scoped=true&"
var script = {}
import style0 from "./cookie.vue?vue&type=style&index=0&id=f7adc38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7adc38a",
  null
  
)

export default component.exports